export default {
  data() {
    return {
      height: "",
      imgList: [{
        url: require("../../assets/images/searchScience/无土栽培.jpg")
      }, {
        url: require("../../assets/images/searchScience/观赏葫芦.jpg")
      }, {
        url: require("../../assets/images/searchScience/架式草莓.jpg")
      }, {
        url: require("../../assets/images/searchScience/科普教育.jpg")
      }, {
        url: require("../../assets/images/searchScience/科学补光.jpg")
      }]
    };
  },
  mounted() {
    console.log(this.$refs.searchBox.clientHeight, "searchBox");
    this.height = this.$refs.searchBox.clientHeight;
    for (let i = 1; i <= 15; i++) {
      this.imgList.unshift({
        url: require("../../assets/images/searchScience/" + i + ".jpg")
      });
    }
  }
};